import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Grid } from 'style';
import { Markdown, Media } from '..';
import ExternalVideoMediaComponent from '../media/media.externalvideo.component';

const SideBySideTextMediaComponent = ({
    text,
    image,
    video,
    textRight,
    loop,
    jobs,
    backgroundColor,
    textColor,
    imageBackgroundColor,
}) => (
    <Grid.Wrapper
        backgroundColor={backgroundColor && backgroundColor.hex}
        textColor={textColor && textColor.hex}
        id="SideBySideTextMediaComponent">
        <div className="wrapper">
        <div className="container-fluid">
            <Col textRight={textRight}  className="row">
                <Left css={column} className="col-xs-12 col-md-6">
                    <Markdown source={text} jobs={jobs} />
                </Left>

                <Right css={column} className="col-xs-12 col-md-6">
                    <MediaWrapper textRight={textRight}>
                        <Media
                            backgroundColor={
                                imageBackgroundColor && imageBackgroundColor.hex
                            }
                            image={image}
                            video={video}
                            loop={loop}
                        />
                    </MediaWrapper>
                </Right>
            </Col>
        </div>
        </div>
    </Grid.Wrapper>
);

const Container = styled.div`
    padding-bottom: 2vw;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    > :first-child {
        margin-top: 0;
    }
`;
const column = css`
    white-space: pre-wrap;
`;
const Left = styled.div`
    flex: 1 1 auto;
    margin: 0;
    margin-bottom: 5.5vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    > :first-child {
        margin-top: 0;
    }
    padding-left: 9%;
    padding-right: 9%;

    // @media (min-width: 1024px) {
    //     flex: 1 1 50vw;
    // }
`;
const Right = styled.div`
    // flex: 1 1 auto;
    // max-width: ${(100 / 18) * 10}vw;

    // @media (min-width: 1024px) {
    //     flex: 1 1 ${(100 / 18) * 8}vw;
    //     max-width: ${(100 / 18) * 8}vw;
    // }
`;

const mediaWrapperPadding = textRight => {
    // if (textRight == false) {
    //   return css`
    //           margin-right: -${containers.padding}px;
    //           @media (min-width: ${containers.innerPX + containers.padding * 2}px) {
    //               margin-right: calc((${containers.innerPX}px - 100vw) / 2);
    //           }
    //           @media (min-width: ${containers.outerPX}px) {
    //               margin-right: ${(containers.innerPX - containers.outerPX) / 2}px;
    //           }
    //       `;
    // }
    // return css`
    //       margin-left: -${containers.padding}px;
    //       @media (min-width: ${containers.innerPX + containers.padding * 2}px) {
    //           margin-left: calc((${containers.innerPX}px - 100vw) / 2);
    //       }
    //       @media (min-width: ${containers.outerPX}px) {
    //           margin-left: ${(containers.innerPX - containers.outerPX) / 2}px;
    //       }
    //   `;
};
const MediaWrapper = styled.div`
    ${props => mediaWrapperPadding(props.textRight)};
`;
const Col = styled.div`

    // flex-direction: ${props => (props.textRight ? 'column-reverse' : 'column')};
    // @media (min-width: 1024px) {
    //     flex-direction: ${props => (props.textRight ? 'row-reverse' : 'row')};
    // }

    ${Left} {
        // padding-right: ${props => props.textRight ? `${(100 / 18) * 3}vw` : '11vw'};
        // padding-left: ${props => props.textRight ? '11vw' : `${(100 / 18) * 3}vw`};

        margin-bottom: ${props => (props.textRight ? 'inherit' : '11vw')};
        @media (min-width: 1024px) {
            margin-bottom: 0;
        }

        order: ${props => (props.textRight ? '2' : '1')};
    }
    ${Right} {
        margin-bottom: ${props => (props.textRight ? '11vw' : 'inherit')};
        @media (min-width: 1024px) {
            margin-bottom: 0;
        }

        order: ${props => (props.textRight ? '1' : '2')};
    }
`;

export default SideBySideTextMediaComponent;
